import type { CostRow } from '../types/product';

export const costRows: CostRow[] = [
  { without: 'Senza un percorso chiaro', consequence: 'Più tempo per orientare l’incontro' },
  { without: 'Senza domande di confronto', consequence: 'Più dubbi tra descrizioni simili' },
  { without: 'Senza una motivazione esplicita', consequence: 'Una proposta più difficile da spiegare' },
  { without: 'Senza una chiusura organizzata', consequence: 'Un passo successivo poco definito' },
  { without: 'Senza accordi sulla disponibilità', consequence: 'Richieste che invadono il tempo personale' },
  { without: 'Senza registrazione', consequence: 'Informazioni difficili da ritrovare' },
  { without: 'Senza follow-up', consequence: 'Il percorso riparte ogni volta da zero' },
  { without: 'Senza comunicazione del servizio', consequence: 'Il cliente comprende meno ciò che offri' },
  { without: 'Senza strumenti riuniti', consequence: 'Appunti e riferimenti sparsi' },
];
